const BOGOTA_TIME_ZONE = "America/Bogota";

const BOGOTA_PARTS_FORMAT = new Intl.DateTimeFormat("en-CA", {
  timeZone: BOGOTA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

/**
 * Parses a date-time sent by the backend. Values without an offset are read as UTC, the zone
 * of the backend JVM in AWS; values with `Z` or an offset are taken as they come.
 */
const parseBackendDateTime = (value) => {
  if (value == null || value === "") return null;
  const str = String(value).trim().replace(/(\.\d{3})\d+/, "$1");
  const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/i.test(str);
  const date = new Date(hasOffset ? str : `${str}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** @returns {{ date: string, time: string } | null} `YYYY-MM-DD` and `HH:mm:ss` in Bogota time. */
export const toBogotaParts = (value) => {
  const date = parseBackendDateTime(value);
  if (!date) return null;
  const parts = Object.fromEntries(
    BOGOTA_PARTS_FORMAT.formatToParts(date).map(({ type, value: part }) => [type, part])
  );
  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    time: `${parts.hour}:${parts.minute}:${parts.second}`,
  };
};

/** V4 solicitudes: derives startDate/startTime from `startedAt` (UTC) when the backend sends it. */
export const withBogotaStart = (item) => {
  const start = toBogotaParts(item?.startedAt);
  return start ? { ...item, startDate: start.date, startTime: start.time } : item;
};
